import {useStatements} from '@/biz/statement.mjs'

export default () => {
    const statements = useStatements()

    const makeMenuItems = statements => statements
        .map(s => {
            // 未启用
            if (1 !== s.status) {
                return null
            }

            // 分组
            if ('1' === s.statementType) {
                if (! s.children) {
                    return null
                }

                const menuItems = makeMenuItems(s.children)

                if (0 < menuItems.length) {
                    return {
                        key: s.statementCode,
                        label: s.statementName,
                        children: menuItems,
                    }
                }
                else {
                    return null
                }
            }
            // 语句
            else {
                if (s.statementContent) {
                    return {
                        key: s.statementCode,
                        type: 'AR',
                        label: s.statementName,
                        suffix: s.statementWinShortcutKey,
                        data: {type: 'statement', statement: s},
                    }
                }
                else {
                    return null
                }
            }
        })
        .filter(a => a)

    return makeMenuItems(statements)
}
